import angular from 'angular';
import template from './participant-video-frame.html';
import full from './participant-video-frame-full/participant-video-frame-full';
import mini from './participant-video-frame-mini/participant-video-frame-mini';
import miniScreen from './participant-screen-frame-mini/participant-screen-frame-mini';
import service from './participant-video-frame.service';
import { EndCallReasons } from '../../../common/services/doxy-analytics/tracks/video-session-end';
import * as call from '../../../modules/call';
class Controller {
    constructor(globalUi, activeComponents, activeStreamService, communicationControl, VideoProviderFactory, $rootScope, $ngRedux) {
        this.globalUi = globalUi;
        this.activeComponents = activeComponents;
        this.activeStreamService = activeStreamService;
        this.communicationControl = communicationControl;
        this.VideoProviderFactory = VideoProviderFactory;
        this.$rootScope = $rootScope;
        this.$ngRedux = $ngRedux;
        this.unsubscribeFromStore = this.$ngRedux.connect((state) => ({
            publisherErrors: call.selectors.getParticipantsPublisherErrors(state),
            isPreviewsListVisible: call.selectors.selectPreviewsListVisibility(state),
        }))(this);
    }
    get hasPublisherError() {
        return this.publisherErrors.has(this.stream.personConnection.id);
    }
    get isMiniFrameVisible() {
        return this.isPreviewsListVisible && (!this.isFull || this.isInGroupCall);
    }
    onToggleAudio() {
        if (this.disabled || !this.stream.hasAudio) {
            return;
        }
        this.activeComponents.phone.turnOffParticipantAudio(this.stream.personConnection.person);
    }
    onCallEnd() {
        if (this.disabled) {
            return;
        }
        if (this.VideoProviderFactory.activeProvider.peopleCollection.length === 1) {
            this.$rootScope.$emit('activeProvider:endReason', EndCallReasons.CANCEL);
        }
        this.communicationControl.remove(this.stream.personConnection.person);
        this.activeStreamService.onStreamDestroy(this.stream.id);
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
const component = {
    template,
    bindings: {
        stream: '<',
        disabled: '<',
        onSelect: '&',
        isPinned: '<',
        username: '<',
        avatarPicture: '<',
        isFull: '<',
        peopleCount: '<',
        isInGroupCall: '<',
        isGalleryView: '<',
        videoSubscriberId: '<',
        isPatient: '<',
        isReconnecting: '<',
    },
    controller: Controller,
};
export default angular
    .module('doxy.videoChat.callFrames.participantVideoFrameComponent', [
    full,
    mini,
    miniScreen,
    service,
])
    .component('participantVideoFrame', component).name;
